import { Icon } from '@/app_components/common/Icon';
import { cn } from '@/app_lib/utils/utils';

interface StarProps {
  value: number;
  selected: boolean;
  rating: number;
  onClick?: () => void;
}

const Star = ({ value, rating, onClick, selected }: StarProps) => {
  const ratingRounded = Math.round(rating);
  return (
    <div className='flex items-center size-4 relative self-center'>
      {/* Full Star is grey or black */}
      <Icon
        className={cn('self-center absolute', !selected && 'text-helper')}
        icon='Star'
        mode='fill'
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onClick?.();
          }
        }}
        role='button'
        size='sm'
      />
      {/* Half star exists or not */}
      <Icon
        className={cn('self-center absolute', value > ratingRounded && 'hidden')}
        icon='StarHalf'
        mode='fill'
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onClick?.();
          }
        }}
        role='button'
        size='sm'
      />
    </div>
  );
};

interface StarRatingProps {
  rating: number;
  setRating?: (value: number) => void;
  disabled?: boolean;
}

export const StarRating = ({ rating, setRating, disabled = false }: StarRatingProps) => {
  // biome-ignore lint/nursery/noMagicNumbers: this is how you round
  const ratingRounded = Math.round(rating / 0.5) * 0.5;
  const starCount = 5;
  return (
    <div className='flex items-center gap-2'>
      {Array.from({ length: starCount }, (_, i) => i + 1).map((value) => (
        <Star
          key={value}
          onClick={() => !disabled && setRating?.(value)}
          rating={ratingRounded}
          selected={value <= ratingRounded}
          value={value}
        />
      ))}
    </div>
  );
};
